<template>
  <div class='create-folder'>
    <el-dialog
      title="新建章"
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="dialogVisible"
      width="35%"
      center>
     <el-form label-width='100px'>
         <el-form-item label="章名称："> <el-input v-model="folderName" placeholder="请输入章名称" ></el-input></el-form-item>
     </el-form>
  <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="addFolder">确 定</el-button>
  </span>
    </el-dialog>
      <el-button  size="small" type="primary" @click="createFolderHander"><i class="wl-icon-wenjianjia1"
      ></i>新建章</el-button>
  </div>

</template>
<script>
export default {
  name: "create-folder",
  props: {},
  data() {
    return {
      dialogVisible: false,
      folderName: ""
    };
  },
  props: {
    courseId: {
      type: String,
      required: true
    },
    folderId: {
      type: String,
      required: "0"
    },
    courseName: {
      type: String,
      required: true
    }
  },
  methods: {
    handleClose(done) {},
    createFolderHander() {
      this.dialogVisible = true;
    },
    addFolder() {
      if (!this.folderName) {
        this.$message.warning("章名称不允许为空");
        return false;
      }
      this.$http.post('/api/XOrg/BookMaterial/saveFolder',{
        folderName: this.folderName,
        courseId: this.courseId,
        courseName: this.courseName,
        folderId: this.folderId 
      }).then( rst => {
        this.folderName = "";
        this.$message.success(rst.msg);
      })
      this.dialogVisible = false;
      this.$emit("done");
    }
  }
};
</script>
<style lang="scss">
.create-folder {
  .wl-icon-wenjianjia1 {
    color: #109eff;
    margin-right: 5px;
    font-size: 16px;
  }
}
</style>




